// extracted by mini-css-extract-plugin
module.exports = {"logo":"Navbar_logo__2LO5e","NavLink":"Navbar_NavLink__rIwfz","divider":"Navbar_divider__1Npa1"};